import logo from './logo.svg';
import CTPFantasyIcon from './CTPFantasyIcon.png'
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={CTPFantasyIcon} className="App-logo" alt="logo" style={{borderRadius: 20}}/>
        <div id='ComingSoonText'>
          MOBILE APP COMING SOON
        </div>
        <div id='ComingSoonText'>
          COMPLETED WEBSITE SOON AFTER
        </div>
      </header>
    </div>
  );
}

export default App;
